module.exports = __webpack_public_path__ + "img/flower_leaf_35.0205f251.png";